export const contentTableConfig = {
  title: '电话异常数据列表',
  propList: [
    {prop: 'corPid', label: '主体ID', minWidth: '80'},
    {prop: 'fromUser', label: '工作账号', minWidth: '80'},
    {prop: 'usedBy', label: '使用人', minWidth: '80'},
    {prop: 'toUser', label: '客户用户ID', minWidth: '80'},
    {prop: 'content', label: '通话内容', minWidth: '120'},
    {prop: 'startTime', label: '通话开始时间', minWidth: '80',slotName: 'startTime'},
    {prop: 'endTime', label: '通话结束时间', minWidth: '80',slotName: 'endTime'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
